import { useDeleteClientDocumentMutation } from "Clients/Api/Mutations/useDeleteClientDocumentMutation";
import { useUploadClientDocumentMutation } from "Clients/Api/Mutations/useUploadClientDocumentMutation";
import { useClientDocumentsQuery } from "Clients/Api/Queries/useClientDocumentsQuery";
import { Resources, useResource } from "Infrastructure/Translations/Resources";
import { DocumentsSection } from "Shared/Documents/DocumentsSection";

interface ClientDocumentsSectionProps {
  clientID: string;
}

export const ClientDocumentsSection = ({
  clientID,
}: ClientDocumentsSectionProps): React.ReactNode => {
  const { t } = useResource();

  const { data, isLoading } = useClientDocumentsQuery(clientID);
  const uploadMutation = useUploadClientDocumentMutation(clientID);
  const deleteMutation = useDeleteClientDocumentMutation(clientID);

  return (
    <DocumentsSection
      title={t(Resources.Clients.ClientDetail.Contracts)}
      documents={data?.items}
      isLoading={isLoading}
      onUpload={(file, displayName) =>
        uploadMutation.mutateAsync({ file, displayName })
      }
      isUploading={uploadMutation.isPending}
      onDelete={deleteMutation.mutateAsync}
    />
  );
};
